<template>
  <div class="ui raised very padded three column grid stackable">
    <div class="four wide column computer only"></div>
    <div class="" v-bind:class="isDesktop() ? 'eight wide column' : 'sixteen wide column'">
      <img class="ui small centered circular image" src="./assets/logo.jpeg">
      <h2 class="ui header centered">
        <a href="https://t.me/secrettravel" target="_blank" rel="noopener noreferrer">
        Secret Travel
        </a>
      </h2>
      <p></p>
      <div class="ui large feed" v-for="event in visibleEvents()" :key="event.id">
        <Event v-bind:event=event />
        <div class="ui divider"></div>
      </div>
    </div>
    <div class="four wide computer only column">
      <div style="margin-top: 200px">
        <div class="ui tag label teal label-departure" v-if="fromCities().length > 0">Отправление</div>
        <div class="ui horizontal list">
          <div class="item" v-for="city in fromCities()" :key="city">
            <a class="ui city" v-bind:class="getFromCls(city)" v-on:click="selectFrom(city);">
              {{ city }}
            </a>
          </div>
        </div>

        <div class="ui tag label orange label-arrival" v-if="toCities().length > 0">Прибытие</div>
        <div class="ui horizontal list">
          <div class="item" v-for="city in toCities()" :key="city">
            <a class="ui city" v-bind:class="getToCls(city)" v-on:click="selectTo(city);">{{ city }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Event from './components/Event.vue';
  import axios from 'axios';

  export default {
    name: 'app',
    components: {
      Event
    },
    props: {},
    data: function(){
      return {
        fromSelected: new Set(),
        toSelected: new Set(),
        events: [],
        windowsWidth: window.innerWidth
      }
    },
    computed: {},
    methods: {
      getFromCls: function (city) {
        return this.fromSelected.has(city) ? 'selected' : '';
      },
      getToCls: function (city) {
        return this.toSelected.has(city) ? 'selected' : '';
      },
      selectFrom: function (city) {
        if (this.fromSelected.has(city)) {
          this.fromSelected.delete(city);
        } else {
          this.fromSelected.add(city);
        }
        this.$forceUpdate();
      },
      selectTo: function (city) {
        if (this.toSelected.has(city)) {
          this.toSelected.delete(city);
        } else {
          this.toSelected.add(city);
        }
        this.$forceUpdate();
      },
      visibleEvents: function () {
        const me = this;
        const isVisible = e => (me.fromSelected.size === 0 || me.fromSelected.has(e['from'])) &&
                (me.toSelected.size === 0 || me.toSelected.has(e['to']));
        return this.events.filter(isVisible);
      },
      fromCities: function() {
        if (this.toSelected.size === 0) {
          return Array.from(new Set(this.events.map(x => x.from))).sort();
        } else {
          return Array.from(new Set(this.events.filter(x => this.toSelected.has(x.to)).map(x => x.from))).sort();
        }
      },
      toCities: function() {
        if (this.fromSelected.size === 0) {
          return Array.from(new Set(this.events.map(x => x.to))).sort();
        } else {
          return Array.from(new Set(this.events.filter(x => this.fromSelected.has(x.from)).map(x => x.to))).sort();
        }
      },
      isDesktop: function() {
        return this.windowsWidth >= 960;
      }
    },
    mounted() {
      window.addEventListener('resize', () => {
        this.windowsWidth = window.innerWidth;
        this.$forceUpdate();
      });

      axios
      .get('http://secret-travel.andr83.io/messages.json', { crossdomain: true })
      .then(response=> {
        this.events = response.data;
      })
    }
  }
</script>

<style scoped>
  a.city {
    border: none;
    margin: 0 .14285714em ;
    padding: 5px 10px;
  }

  a.city.selected {
    background: #e8e8e8;;
    border-radius: 3px;
    color: rgba(0,0,0,.6);
  }

  .ui.horizontal.list {
    display: block;
  }

  .ui.horizontal.list > .item {
    margin: 0 15px 0 0;
  }

  .label-departure {
    margin-bottom: 10px !important;
  }

  .label-arrival {
    margin-bottom: 10px !important;
    margin-top: 20px !important;
  }
</style>
